import mapResponseToDictionary from './mappers/mapResponseToDictionary'

export default function addPaymentDictionaries(api: GlobalFetch) {
  return async function(name) {
    const requestBody = {
      deleted: 0,
      name,
    }

    const buildUrl = `/api/v2/typeofpaymentdictionary/index/`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    const responseBody: IData = await response.json()

    return mapResponseToDictionary(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_user: string
  name: string
  deleted: '0' | '1'
  create_date: string
  modify_date: string
}
